import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import { BaseControl } from "@cloudpivot/form/src/common/controls/base-control";
import { UploadControl } from "@cloudpivot/form/src/common/controls/upload-control";
import PCImagePreview from "@cloudpivot/form/src/common/components/pc-image-preview.vue";
let InputSignsture = class InputSignsture extends BaseControl {
    constructor() {
        super(...arguments);
        this.bs64Img = "";
        this.isPreviewImage = false;
        this.hover = false;
    }
    mouseListener(type) {
        this.hover = Boolean(type);
    }
    setControl() {
        // PC端只能查看，所以不能设置必填
        this.ctrl.required = false;
        this.handleValueChange(this.ctrl.value);
    }
    handleValueChange(files) {
        if (files && files.length > 0) {
            let fileObj = "";
            if (files[0].url) {
                // status状态为done则说明为图片
                fileObj = files.find((f) => f.status === "done");
                this.bs64Img = fileObj.url;
                return;
            }
            if (files[0].mimeType) {
                fileObj = files.find((f) => f.mimeType.indexOf('image') > -1);
                this.bs64Img = UploadControl.service.getDownloadUrl(fileObj);
            }
        }
        else {
            this.bs64Img = "";
        }
    }
};
InputSignsture = tslib_1.__decorate([
    Component({
        name: "input-signsture",
        components: {
            ImgPreview: PCImagePreview
        }
    })
], InputSignsture);
export default InputSignsture;
